import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-left ml-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-lg" }, "Criar plantão")
], -1)
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-b my-4" }, null, -1)
const _hoisted_4 = { class: "station-form-category-container mt-6 mb-6 text-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "station-form-category-title" }, "Periodicidade", -1)
const _hoisted_6 = { class: "station-form-category-container mb-6 text-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "station-form-category-title" }, "Regra de proporcionalidade", -1)
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "flex flex-col md:flex-row gap-3 md:gap-5 justify-end mt-4 px-3" }
const _hoisted_10 = { class: "flex gap-3" }
const _hoisted_11 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_12 = { class: "flex-1" }
const _hoisted_13 = { class: "flex-1" }

import DashboardModalShell from '@/modules/company/Dashboard/mobile/DashboardModalShell.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import {
  reactive,
  ref,
  watch,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
  type PropType
} from 'vue'
import {
  buildSectorSpecialtySummary,
  estimateRecurringStationCount,
  getDate,
  getStartDateAndEndDate,
  type CreateStationPrefill
} from './helpers'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { useHealthUnitStore } from '@/pinia-store/useHealthUnitStore'
import { usePositionStore } from '@/pinia-store/usePositionStore'
import { CompanyDoctorInviteStatusEnum } from '@/Network/Types/Requests/CompanyRequests'
import { storeToRefs } from 'pinia'
import { useToast } from 'vue-toastification'
import { CreateStationRequest, PositionType } from '@/Network/Types/Requests/StationRequests'
import Network from '@/Network'
import { useStationStore } from '@/pinia-store/useStationStore'
import LocaleAndScheduleForm from './components/form/locale.and.schedule.form.vue'
import DoctorInfosForm from './components/form/doctor.infos.form.vue'
import HourAndDateForm from './components/form/hours.and.date.form.vue'
// import ObservationForm from './components/form/observation.form.vue'
import SelectUserSponsor from '@/components/designSystem/Select/SelectUserSponsor.vue'
import { getProportionalityRuleTitle } from '@/utils/schedule'
import ConsecutiveHoursBlockAlert from '@/components/designSystem/Alerts/ConsecutiveHoursBlockAlert.vue'
import ScheduleOverlapAlert from '@/components/designSystem/Alerts/ScheduleOverlapAlert.vue'
import { useConsecutiveHoursCheck } from '@/hooks/useConsecutiveHoursCheck'
import { useStationOverlapAlerts } from '@/hooks/useStationOverlapAlerts'
import type { ConsecutiveHoursCheckCandidate } from '@/Network/Types/Requests/StationRequests'
import { isStationDurationExceeded } from '@/modules/company/Dashboard/modals/stationErrors'
import { useErrorToast } from '@/composables/useErrorToast'
import SectorSpecialtyFields from '@/components/SectorSpecialty/SectorSpecialtyFields.vue'
import type { StationSectorRef } from '@/Network/Types/Responses/StationResponses'
import {
  findSpecialtyMatch,
  toSpecialtyInput,
  type SpecialtySelection
} from '@/utils/sectorSpecialty'
import type { SpecialtyOptionsResponse } from '@/Network/Types/Responses/SpecialtyResponses'
import { readLastUsed, writeLastUsed } from '@/utils/lastUsedSectorSpecialty'
import { useAuthStore } from '@/pinia-store/useAuthStore'
import { useSectorStore } from '@/pinia-store/useSectorStore'
import { useSpecialtyStore } from '@/pinia-store/useSpecialtyStore'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import CoverageModeSelector from '@/components/Coverage/CoverageModeSelector.vue'
import { useUnidentifiedCoverageLock } from '@/components/Coverage/useUnidentifiedCoverageLock'
import type { LockableSchedule } from '@/components/Coverage/useUnidentifiedCoverageLock'
import CoverageResponsibleField from '@/components/Coverage/CoverageResponsibleField.vue'
import { CoverageMode } from '@/Network/Types/Requests/CoverageRequests'
import { buildCoverageInput, canMarkUnidentified, scheduleSupportsCoverage } from '@/utils/coverage'
import { getCoverageErrorMessage } from '@/utils/coverageErrors'
import PlaceholderDoctorBlockedModal from '@/components/Coverage/PlaceholderDoctorBlockedModal.vue'
import { usePlaceholderDoctorBlocked } from '@/composables/usePlaceholderDoctorBlocked'
import {
  findDoctorTitle,
  focusCoverageResponsibleSelect,
  focusFieldBySelector,
  isBlockedPlaceholderDoctor,
  reportPreventivePlaceholderAttempt,
  type PlaceholderDoctorFlags
} from '@/utils/placeholderDoctor'
import { useDoctorStore } from '@/pinia-store/useDoctorStore'

const DOCTOR_SELECT_SELECTOR = '[data-testid="create-station-doctor-select"]'
const LAST_USED_HINT = 'Último usado nesta escala'
const CAMPO_OBRIGATORIO = 'O campo é obrigatório'

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity

export default /*#__PURE__*/_defineComponent({
  __name: 'create.station.modal',
  props: {
  showModal: {
    type: Boolean,
    default: false
  },
  /** "Criar vaga HH–HH" da Timeline no celular (R4): empresa, unidade, escala, datas e setor. */
  prefill: {
    type: Object as PropType<CreateStationPrefill | null>,
    default: null
  },
  /** R6: tela cheia no celular. O IndexV2 liga com `isMobileLayout`. */
  mobileShell: {
    type: Boolean,
    default: false
  }
},
  emits: ['closeModal'],
  setup(__props, { emit }) {

const props = __props;




// Cada abertura invalida um pré-preenchimento ainda em andamento (fechar/reabrir no meio).
let prefillRun = 0
watch(
  () => props.showModal,
  (newVal) => {
    prefillRun += 1
    if (newVal) {
      clearAllInputs()
      if (props.prefill) void applyPrefill(props.prefill, prefillRun)
    }
  }
)

const defaultValueRepetionDays = {
  '0': '0',
  '1': '0',
  '2': '0',
  '3': '0',
  '4': '0',
  '5': '0',
  '6': '0'
}

const defaultValues = {
  company: undefined as number | undefined,
  healthUnit: '',
  schedule: 0,
  doctorId: '',
  userSponsorId: null, // Old: sponsorDoctorId
  value: 0,
  inCash: false,
  advanceRequested: false,
  advancePaid: false,
  formation: '',
  shift: '',
  position: '',
  team: '',
  urlConviteDoctor: '',
  stationType: 'COBERTURA',
  ourTeam: true,
  date: '',
  endDate: '',
  timezone: '-03:00',
  startHour: '',
  endHour: '',
  configurationRepetition: 'no-repeat',
  valueRepetition: [],
  finishedAtUntil: '',
  finishedAtAfter: 1,
  finishedAt: 'always',
  repetionDays: { ...defaultValueRepetionDays },
  positionByRowStations: [],
  observations: [],
  sector: null as StationSectorRef | null,
  specialty: null as SpecialtySelection | null,
  requiresDoctorPaymentFormation: false,
  coverage: CoverageMode.DOCTOR as CoverageMode,
  coverageResponsibleId: null as number | null,
  coverageNote: ''
}

const form = reactive({ values: { ...defaultValues } })
const scheduleEndDate = ref<string | null>(null)
const formErrors = ref<{
  company?: string
  position?: string
  healthUnit?: string
  schedule?: string
  userSponsorId?: string
  repetitionErr?: string
  positionErr?: string
  shift?: string
  startHour?: string
  endDate?: string
  endHour?: string
  dateTimeError?: string
  date?: string
  coverageResponsibleId?: string
}>({})
const isLoading = ref(false)
const activeIndex = ref<number | null>(null)
const toast = useToast()
const { notifyError } = useErrorToast()
const stationStore = useStationStore()
const { listSchedules } = storeToRefs(useScheduleStore())
const { listHealthUnitsByCompany } = storeToRefs(useHealthUnitStore())
// Nome da unidade no hint do responsável ("…Lista da unidade <Nome>."), como no Alterar/Remover.
const selectedHealthUnitName = computed(
  () =>
    listHealthUnitsByCompany.value.find((unit) => unit.value === String(form.values.healthUnit))
      ?.title ?? null
)
const proportionalityRuleTitle = ref<string | null>('N/A')
const validationState = ref({ isValid: false, message: null as string | null })

// Feature detection: só o backend novo manda `allowUnregisteredDoctor` na escala.
const coverageSupported = ref(false)
const allowUnidentified = ref(false)
const coverageSchedule = ref<LockableSchedule>(null)
const { unidentifiedLocked, canOpenScheduleSettings, openScheduleSettings } =
  useUnidentifiedCoverageLock(() => coverageSchedule.value)
const isUnidentified = computed(() => form.values.coverage === CoverageMode.UNIDENTIFIED)
const isDoctorMode = computed(
  () => !coverageSupported.value || form.values.coverage === CoverageMode.DOCTOR
)

// Aviso do médico "coringa" (PLACEHOLDER_DOCTOR_BLOCKED): 422 do BE ou bloqueio preventivo.
const placeholderBlocked = usePlaceholderDoctorBlocked()
// Aviso aberto pela seleção no autocomplete: ao fechar ("Entendi"/ESC), o foco volta ao médico.
let focusDoctorOnClose = false
watch(placeholderBlocked.isOpen, (open) => {
  if (open || !focusDoctorOnClose) return
  focusDoctorOnClose = false
  void focusFieldBySelector(DOCTOR_SELECT_SELECTOR)
})
// `blockedPlaceholderDoctorIds` da escala (BE novo); null = sem a lista, só o 422 vale.
const placeholderFlags = ref<PlaceholderDoctorFlags | null>(null)
const { listDoctorsCompany } = storeToRefs(useDoctorStore())
const doctorTitle = (doctorId: unknown) =>
  findDoctorTitle(listDoctorsCompany.value, doctorId as string | number | null)

// Seleção de médico: um "coringa" bloqueado nesta escala abre o aviso na hora e NÃO é aceito
// (o autocomplete é controlado, então o valor volta ao anterior).
function onDoctorSelected(value: string | number | null | undefined) {
  if (isBlockedPlaceholderDoctor(placeholderFlags.value, value)) {
    placeholderBlocked.open(doctorTitle(value))
    focusDoctorOnClose = true
    reportPreventivePlaceholderAttempt(
      (payload) => Network.station.reportPlaceholderAllocationAttempt(payload),
      { doctorId: Number(value), scheduleId: Number(form.values.schedule) }
    )
    return
  }
  form.values.doctorId = (value ?? '') as typeof form.values.doctorId
}

// "Usar Ocupado sem identificação": o watch do modo limpa médico/sponsor/formação.
function onUseUnidentified() {
  // O primário leva o foco ao responsável (o campo de médico some com UNIDENTIFIED).
  focusDoctorOnClose = false
  form.values.coverage = CoverageMode.UNIDENTIFIED
  form.values.doctorId = ''
  void focusCoverageResponsibleSelect()
}

// Time escolhido antes de entrar em UNIDENTIFIED; restaurado ao sair (null = nada a restaurar).
let teamBeforeUnidentified: string | null = null

// Nada escondido viaja: ao sair de "Médico" limpa médico/sponsor/formação; o
// ocupado sem identificação é sempre time externo (Q15) e, ao sair dele, o time volta ao anterior.
watch(
  () => form.values.coverage,
  (mode, previousMode) => {
    if (mode !== CoverageMode.DOCTOR) {
      form.values.doctorId = ''
      form.values.userSponsorId = null
      form.values.formation = ''
    }
    if (mode === CoverageMode.UNIDENTIFIED) {
      if (previousMode !== CoverageMode.UNIDENTIFIED) teamBeforeUnidentified = form.values.team
      form.values.team = 'Externo'
    } else {
      if (previousMode === CoverageMode.UNIDENTIFIED && teamBeforeUnidentified !== null) {
        form.values.team = teamBeforeUnidentified
      }
      teamBeforeUnidentified = null
      form.values.coverageResponsibleId = null
      form.values.coverageNote = ''
    }
  }
)

// A11: com a flag desligada o modal é o da base (sem bloco, sem sugestão, payload sem setor/especialidade).
const isDashboardV2 = useFeatureFlags().flags.enabledDashboardV2
const authStore = useAuthStore()
const sectorStore = useSectorStore()
const specialtyStore = useSpecialtyStore()
const sectorSuggested = ref(false)
const specialtySuggested = ref(false)

async function suggestSector(last: StationSectorRef, scheduleId: number): Promise<void> {
  const unitId = Number(form.values.healthUnit)
  if (!unitId) return
  const sectors = await sectorStore.fetchByHealthUnit(unitId)
  // A escala pode ter mudado, ou o usuário já ter escolhido, enquanto a lista carregava.
  if (Number(form.values.schedule) !== scheduleId || form.values.sector) return
  const active = sectors.find((sector) => sector.id === last.id && !sector.archivedAt)
  if (!active) return
  form.values.sector = { id: active.id, name: active.name }
  sectorSuggested.value = true
}

/** Confere contra o catálogo atual (sem arquivadas); sem catálogo carregado, sugere como está. */
function resolveSuggestedSpecialty(
  last: SpecialtySelection,
  options: SpecialtyOptionsResponse | null
): SpecialtySelection | null {
  if (!options) return last
  if (last.kind === 'new') {
    const match = findSpecialtyMatch(last.name, options)
    return match ? { kind: match.kind, id: match.option.id, name: match.option.name } : last
  }
  const list = last.kind === 'official' ? options.official : options.company
  const current = list.find((option) => option.id === last.id)
  return current ? { kind: last.kind, id: current.id, name: current.name } : null
}

async function suggestSpecialty(last: SpecialtySelection, scheduleId: number): Promise<void> {
  const companyId = Number(form.values.company)
  const options = companyId ? await specialtyStore.fetchOptions(companyId) : null
  if (Number(form.values.schedule) !== scheduleId || form.values.specialty) return
  const suggestion = resolveSuggestedSpecialty(last, options)
  if (!suggestion) return
  form.values.specialty = suggestion
  specialtySuggested.value = true
}

/**
 * P2: só pré-seleção editável; vem do último plantão criado nesta escala por este usuário.
 * Nunca sobrescreve o que o usuário já escolheu nem sugere item arquivado/removido.
 */
async function applyLastUsedSuggestion(scheduleId: number): Promise<void> {
  const last = readLastUsed(authStore.getUserId, scheduleId)
  if (!last) return
  await Promise.all([
    last.sector ? suggestSector(last.sector, scheduleId) : undefined,
    last.specialty ? suggestSpecialty(last.specialty, scheduleId) : undefined
  ])
}

const onSectorChange = (value: StationSectorRef | null) => {
  form.values.sector = value
  sectorSuggested.value = false
}

const onSpecialtyChange = (value: SpecialtySelection | null) => {
  form.values.specialty = value
  specialtySuggested.value = false
}

const recurrenceSummary = computed(() => {
  if (form.values.configurationRepetition === 'no-repeat') return null
  const count = estimateRecurringStationCount({
    date: form.values.date,
    finishedAt: form.values.finishedAt,
    finishedAtAfter: Number(form.values.finishedAtAfter),
    finishedAtUntil: form.values.finishedAtUntil,
    repetionDays: form.values.repetionDays
  })
  return buildSectorSpecialtySummary(count, form.values.sector, form.values.specialty)
})

const {
  violations: consecutiveHoursViolations,
  hasViolations: hasConsecutiveHoursViolations,
  runCheck: runConsecutiveHoursCheck,
  applyErrorViolations: applyConsecutiveHoursError,
  clearViolations: clearConsecutiveHoursViolations
} = useConsecutiveHoursCheck()

// Conflito de agenda: aviso a posteriori (o backend devolve junto da vaga ja criada).
// Nao bloqueia o submit — so segura o modal aberto para o usuario ler.
const {
  alerts: overlapAlerts,
  hasAlerts: hasOverlapAlerts,
  applyFromResponse: applyOverlapAlerts,
  clear: clearOverlapAlerts
} = useStationOverlapAlerts()

// Mexer nos campos que definem o candidato reabilita o botão de salvar.
watch(
  () => [
    form.values.doctorId,
    form.values.schedule,
    form.values.team,
    form.values.date,
    form.values.endDate,
    form.values.startHour,
    form.values.endHour
  ],
  () => clearConsecutiveHoursViolations()
)

function buildConsecutiveHoursCandidates(
  startDate: Date,
  endDate: Date
): ConsecutiveHoursCheckCandidate[] {
  const doctorId = form.values.doctorId ? Number(form.values.doctorId) : null
  if (!doctorId) return []
  return [
    {
      scheduleId: Number(form.values.schedule),
      doctorId,
      startHour: startDate.toISOString(),
      endHour: endDate.toISOString(),
      ourTeam: [undefined, null, '', 'Interno'].includes(form.values.team),
      timezone: form.values.timezone
    }
  ]
}

const handleValidation = (status: { isValid: boolean; message: string | null }) => {
  validationState.value = status
}

watch(
  () => form.values.schedule,
  (newValue) => {
    const tz = listSchedules.value.find((s) => s.value === String(newValue))
    form.values.timezone = tz?.timezone ?? '-03:00'

    setproportionalityRuleTitle(newValue)
    resetDependentFields()
    if (newValue && isDashboardV2) void applyLastUsedSuggestion(Number(newValue))
  }
)

const fieldsToWatch: Array<keyof typeof form.values> = [
  'company',
  'healthUnit',
  'schedule',
  'shift',
  'position',
  'date',
  'startHour',
  'endDate',
  'endHour',
  'userSponsorId',
  'coverageResponsibleId'
]
fieldsToWatch.forEach((field) => {
  watch(
    () => form.values[field],
    (newValue) => {
      if (newValue && formErrors.value[field]) {
        delete formErrors.value[field]
      }
    }
  )
})

async function setproportionalityRuleTitle(scheduleId: number) {
  if (!scheduleId) return
  const schedule = await Network.schedule.getById(scheduleId)
  scheduleEndDate.value = schedule.endDate
  coverageSupported.value = scheduleSupportsCoverage(schedule)
  allowUnidentified.value = canMarkUnidentified(schedule)
  coverageSchedule.value = schedule ? { ...schedule, id: schedule.id ?? scheduleId } : null
  placeholderFlags.value = schedule ?? null
  if (schedule && schedule.proportionalityRule) {
    proportionalityRuleTitle.value = getProportionalityRuleTitle(schedule.proportionalityRule)
    return
  }
  proportionalityRuleTitle.value = 'Erro ao procurar regra de proporcionalidade.'
}

const validateForm = (): boolean => {
  formErrors.value = {}
  const {
    company,
    healthUnit,
    schedule,
    shift,
    configurationRepetition,
    valueRepetition,
    userSponsorId,
    position,
    date,
    startHour,
    endDate,
    endHour
  } = form.values

  if (!startHour) {
    formErrors.value = { ...formErrors.value, startHour: 'Data e hora de início são obrigatórias' }
  }

  if (!endHour) {
    formErrors.value = { ...formErrors.value, endHour: CAMPO_OBRIGATORIO }
  }

  if (!validationState.value.isValid)
    formErrors.value = {
      ...formErrors.value,
      dateTimeError: `${validationState.value.message || ''}`
    }

  if (!company) formErrors.value = { ...formErrors.value, company: CAMPO_OBRIGATORIO }
  if (!healthUnit) formErrors.value = { ...formErrors.value, healthUnit: CAMPO_OBRIGATORIO }
  if (!schedule) formErrors.value = { ...formErrors.value, schedule: CAMPO_OBRIGATORIO }
  if (!shift) formErrors.value = { ...formErrors.value, shift: CAMPO_OBRIGATORIO }

  if (!position && form.values.configurationRepetition == 'no-repeat')
    formErrors.value = { ...formErrors.value, position: CAMPO_OBRIGATORIO }
  if (!userSponsorId && form.values.doctorId)
    formErrors.value = {
      ...formErrors.value,
      userSponsorId: CAMPO_OBRIGATORIO
    }
  if (configurationRepetition === 'custom' && !valueRepetition?.length)
    formErrors.value = { ...formErrors.value, repetitionErr: 'Este campo é obrigatório' }

  const repetitionIsActive = configurationRepetition !== 'no-repeat'
  if (repetitionIsActive) {
    const hasInvalidPosition = positionFormatedForApi.value.some((p) => !p.id)
    const hasMissingPositions = positionFormatedForApi.value.length < biggerCountRepetionDays.value

    if (positionFormatedForApi.value.length === 0 || hasInvalidPosition || hasMissingPositions) {
      formErrors.value = {
        ...formErrors.value,
        positionErr: 'Por favor, verifique se selecionou todas as posições da repetição!'
      }
    }
  }
  if (!date) formErrors.value.date = CAMPO_OBRIGATORIO
  if (!startHour) formErrors.value.startHour = CAMPO_OBRIGATORIO
  if (!endDate) formErrors.value.endDate = CAMPO_OBRIGATORIO
  if (!endHour) formErrors.value.endHour = CAMPO_OBRIGATORIO

  if (!userSponsorId && form.values.doctorId) formErrors.value.userSponsorId = CAMPO_OBRIGATORIO

  if (configurationRepetition === 'custom' && !valueRepetition?.length)
    formErrors.value.repetitionErr = CAMPO_OBRIGATORIO

  if (isUnidentified.value && !form.values.coverageResponsibleId)
    formErrors.value.coverageResponsibleId = 'Selecione o responsável pela cobertura'

  const hasErrs = Object.keys(formErrors.value).length > 0
  if (hasErrs) {
    const errorMsg = formErrors.value.dateTimeError
      ? formErrors.value.dateTimeError
      : 'Faltam preencher alguns campos obrigatórios'

    toast.error(errorMsg, {
      timeout: 8000
    })
    return false
  }
  return true
}

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
const handleSubmit = async () => {
  if (!validateForm()) return

  isLoading.value = true
  const {
    schedule,
    healthUnit,
    configurationRepetition,
    inCash,
    doctorId,
    userSponsorId, // Old: sponsorDoctorId
    team,
    stationType,
    value,
    startHour,
    endHour,
    finishedAtUntil,
    date,
    timezone
  } = form.values

  const { startDate, endDate } = getStartDateAndEndDate({
    date,
    startHour,
    endHour,
    timezone,
    endDateSelected: form.values.endDate
  })

  const canProceed = await runConsecutiveHoursCheck(
    buildConsecutiveHoursCandidates(startDate, endDate)
  )
  if (!canProceed) {
    isLoading.value = false
    toast.error('Limite de horas consecutivas excedido. Veja os detalhes no formulário.')
    return
  }

  const finishedAtUntilFormatted =
    form.values.finishedAt === 'until'
      ? getDate({ date: finishedAtUntil, hours: '23:59', timezone: timezone })
      : undefined
  const payload: CreateStationRequest = {
    scheduleId: Number(schedule),
    healthUnitId: Number(healthUnit),
    shift: Number(form.values.shift),
    ...(isDashboardV2
      ? {
          sectorId: form.values.sector?.id ?? undefined,
          specialty: toSpecialtyInput(form.values.specialty) ?? undefined
        }
      : {}),
    formation:
      form.values.requiresDoctorPaymentFormation && form.values.doctorId
        ? Number(form.values.formation)
        : undefined,
    doctorId: doctorId ? Number(doctorId) : undefined,
    userSponsorId: userSponsorId && form.values.doctorId ? Number(userSponsorId) : undefined, // Old: sponsorDoctorId
    ourTeam: isUnidentified.value ? false : [undefined, null, '', 'Interno'].includes(team),
    stationType,
    value: value ? Number(value) : undefined,
    config: {
      date: startDate,
      startHour: startDate,
      endHour: endDate,
      finishAt: finishedAtUntilFormatted,
      repeatIn: configurationRepetition === 'no-repeat' ? [] : repeatInDays.value,
      positionInStationsByRepetionDays: positionFormatedForApi.value,
      positionId:
        positionFormatedForApi.value.length === 0 &&
        form.values.configurationRepetition == 'no-repeat'
          ? Number(form.values.position)
          : undefined,
      repetionDays: form.values.repetionDays,
      finishAtType: form.values.finishedAt,
      occurrence: form.values.finishedAtAfter,
      timezone
    },
    inCash,
    observations: form.values.observations,
    advancePaid: form.values.advancePaid,
    advanceRequested: form.values.advanceRequested,
    ...(coverageSupported.value
      ? buildCoverageInput({
          mode: form.values.coverage,
          doctorId: doctorId ? Number(doctorId) : null,
          responsibleId: form.values.coverageResponsibleId,
          note: form.values.coverageNote
        })
      : {})
  }
  try {
    const created = await Network.station.create(payload)
    if (isDashboardV2) {
      writeLastUsed(authStore.getUserId, Number(schedule), {
        sector: form.values.sector,
        specialty: form.values.specialty
      })
    }
    if (isDashboardV2 && form.values.specialty?.kind === 'new' && form.values.company) {
      // A especialidade nova passou a existir no catálogo da empresa.
      void specialtyStore.fetchOptions(Number(form.values.company), { force: true })
    }
    toast.success('Plantão criado com sucesso')
    await stationStore.getListStations()

    // A vaga ja esta gravada; se o backend acusou sobreposicao, o modal fica aberto
    // exibindo o aviso ambar em vez de fechar e engolir a informacao.
    if (applyOverlapAlerts(created)) return

    emit('closeModal')
  } catch (error: unknown) {
    // Guards F10: o service normaliza via handleError (ServiceError) e os guards
    // fazem unwrap do axios original — os ramos específicos ficam como estão.
    if (applyConsecutiveHoursError(error)) {
      toast.error('Limite de horas consecutivas excedido. Veja os detalhes no formulário.')
    } else if (isStationDurationExceeded(error)) {
      toast.error('A duração do plantão não pode ser superior a 24 horas.')
    } else {
      // Erros de cobertura viram a frase do catálogo; os demais seguem o
      // notifyError (a mensagem específica do backend chega intacta ao usuário).
      // Médico "coringa" (422 PLACEHOLDER_DOCTOR_BLOCKED): aviso descritivo em vez do toast.
      if (placeholderBlocked.handleError(error, doctorTitle(form.values.doctorId))) {
        focusDoctorOnClose = false
        return
      }
      const coverageMessage = getCoverageErrorMessage(error)
      if (coverageMessage) toast.error(coverageMessage)
      else notifyError(error, 'Não foi possível criar o plantão')
    }
  } finally {
    isLoading.value = false
  }
}

const clearAllInputs = () => {
  form.values = { ...defaultValues }
  formErrors.value = {}
  activeIndex.value = null
  isLoading.value = false
  clearOverlapAlerts()
}

const healthUnitStore = useHealthUnitStore()
const scheduleStore = useScheduleStore()
const positionStore = usePositionStore()
const doctorStore = useDoctorStore()

/** Passo da escala do `applyPrefill`: posições, escala e, depois do watcher dela, o setor. */
async function applyPrefillSchedule(
  scheduleId: number,
  sector: StationSectorRef | null,
  stale: () => boolean
): Promise<void> {
  await positionStore.getByScheduleId(scheduleId)
  if (stale()) return
  form.values.schedule = scheduleId
  const selected = listSchedules.value.find((s) => s.value === String(scheduleId))
  if (selected) {
    form.values.requiresDoctorPaymentFormation = selected.requiresDoctorPaymentFormation
  }
  // O watcher da escala limpa setor/especialidade e sugere a última usada: o setor do
  // buraco entra depois dele (a sugestão não sobrescreve setor já escolhido).
  await nextTick()
  if (stale()) return
  if (sector) form.values.sector = sector
}

/**
 * Pré-preenche na ordem dos selects (empresa → unidade → escala), esperando os watchers de
 * cada campo limparem os dependentes antes do próximo, e com as mesmas cargas que o
 * `LocaleAndScheduleForm` faz ao escolher cada um. Uma abertura nova (`prefillRun`) aborta.
 */
async function applyPrefill(prefill: CreateStationPrefill, run: number): Promise<void> {
  const stale = () => run !== prefillRun || !props.showModal
  try {
    if (prefill.companyId) await applyPrefillLocale(prefill, prefill.companyId, stale)
  } catch (error) {
    // Mesmo tratamento do `LocaleAndScheduleForm`: a carga falhou, o usuário escolhe à mão.
    console.error('Erro ao pré-preencher o plantão:', error)
  } finally {
    // Datas e horas não dependem das cargas: entram mesmo se alguma delas falhar.
    if (!stale()) {
      Object.assign(form.values, {
        date: prefill.date,
        endDate: prefill.endDate,
        startHour: prefill.startHour,
        endHour: prefill.endHour
      })
    }
  }
}

/** Passo empresa → unidade → escala do `applyPrefill`; para quando a abertura fica velha. */
async function applyPrefillLocale(
  prefill: CreateStationPrefill,
  companyId: number,
  stale: () => boolean
): Promise<void> {
  form.values.company = companyId
  await nextTick()
  await Promise.all([
    healthUnitStore.setHealthUnitsByCompany(companyId),
    doctorStore.applyFilters(
      {
        search: '',
        names: [],
        crms: [],
        crmUFs: [],
        companies: [String(companyId)],
        inviteStatus: [
          CompanyDoctorInviteStatusEnum.ACCEPTED,
          CompanyDoctorInviteStatusEnum.PENDING
        ]
      },
      false
    )
  ])
  if (stale()) return
  form.values.healthUnit = String(prefill.healthUnitId)
  await nextTick()
  await scheduleStore.setSchedulesByHealthUnit(prefill.healthUnitId)
  if (stale()) return
  if (prefill.scheduleId) await applyPrefillSchedule(prefill.scheduleId, prefill.sector, stale)
}

const biggerCountRepetionDays = computed(() => {
  return Math.max(0, ...Object.values(form.values.repetionDays).map((v) => Number(v)))
})

const positionFormatedForApi = computed((): Array<PositionType> => {
  return form.values.positionByRowStations.map((v): PositionType => ({ id: v })).filter((v) => v.id)
})

const repeatInDays = computed(() => {
  const repeatInDaysTemp: string[] = []
  Object.entries(form.values.repetionDays).forEach(([day, count]) => {
    if (Number(count) > 0) {
      repeatInDaysTemp.push(day)
    }
  })
  return repeatInDaysTemp
})

const resetDependentFields = () => {
  scheduleEndDate.value = null
  form.values.position = defaultValues.position
  form.values.shift = defaultValues.shift
  form.values.team = defaultValues.team
  form.values.doctorId = defaultValues.doctorId
  form.values.userSponsorId = defaultValues.userSponsorId
  form.values.value = defaultValues.value
  form.values.inCash = defaultValues.inCash
  form.values.advanceRequested = defaultValues.advanceRequested
  form.values.advancePaid = defaultValues.advancePaid
  form.values.formation = defaultValues.formation
  form.values.sector = defaultValues.sector
  form.values.specialty = defaultValues.specialty
  coverageSupported.value = false
  allowUnidentified.value = false
  coverageSchedule.value = null
  placeholderFlags.value = null
  form.values.coverage = CoverageMode.DOCTOR
  form.values.coverageResponsibleId = null
  form.values.coverageNote = ''
  // Reset volta o time ao default: o watcher não deve restaurar o time de antes do UNIDENTIFIED.
  teamBeforeUnidentified = null
  sectorSuggested.value = false
  specialtySuggested.value = false
}
const resetScheduleAndDependents = () => {
  form.values.schedule = defaultValues.schedule
  resetDependentFields()
}

const closeModal = () => {
  emit('closeModal')
}

const handleKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    // O ESC do aviso do médico coringa fecha só o aviso.
    if (placeholderBlocked.isOpen.value) return
    closeModal()
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown)
})

watch(
  () => form.values.company,
  () => {
    form.values.healthUnit = defaultValues.healthUnit
    resetScheduleAndDependents()
  }
)
watch(
  () => form.values.healthUnit,
  () => {
    resetScheduleAndDependents()
  }
)

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createBlock(DashboardModalShell, {
    open: __props.showModal,
    "full-screen": __props.mobileShell,
    title: "Criar plantão",
    "test-id": "create-station-panel",
    onClose: closeModal,
    hasFooterBorder: true,
    hasHeaderBorder: true
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        (_unref(hasOverlapAlerts))
          ? (_openBlock(), _createBlock(FilledButton, {
              key: 0,
              class: "bg-primary30 w-full md:w-auto",
              "data-testid": "create-station-overlap-ack-button",
              onClick: closeModal,
              text: "Entendi, fechar"
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(OutlinedButton, {
                onClick: closeModal,
                text: "Cancelar",
                class: "w-full md:w-auto"
              }),
              _createVNode(FilledButton, {
                class: "bg-primary30 w-full md:w-auto",
                "data-testid": "create-station-submit-button",
                disabled: isLoading.value || _unref(hasConsecutiveHoursViolations),
                loading: isLoading.value,
                onClick: handleSubmit,
                text: "Salvar e criar plantão"
              }, null, 8, ["disabled", "loading"])
            ], 64))
      ])
    ]),
    dock: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        (_unref(hasOverlapAlerts))
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(FilledButton, {
                class: "bg-primary30",
                "data-testid": "create-station-overlap-ack-button",
                width: "100%",
                height: "44px",
                text: "Entendi, fechar",
                onClick: closeModal
              })
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(OutlinedButton, {
                  width: "100%",
                  height: "44px",
                  text: "Cancelar",
                  onClick: closeModal
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(FilledButton, {
                  class: "bg-primary30",
                  "data-testid": "create-station-submit-button",
                  width: "100%",
                  height: "44px",
                  text: "Salvar",
                  disabled: isLoading.value || _unref(hasConsecutiveHoursViolations),
                  loading: isLoading.value,
                  onClick: handleSubmit
                }, null, 8, ["disabled", "loading"])
              ])
            ], 64))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(LocaleAndScheduleForm, {
          stacked: __props.mobileShell,
          company: form.values.company,
          "onUpdate:company": _cache[0] || (_cache[0] = ($event: any) => ((form.values.company) = $event)),
          "health-unit": form.values.healthUnit,
          "onUpdate:healthUnit": _cache[1] || (_cache[1] = ($event: any) => ((form.values.healthUnit) = $event)),
          schedule: form.values.schedule,
          "onUpdate:schedule": _cache[2] || (_cache[2] = ($event: any) => ((form.values.schedule) = $event)),
          doctor: form.values.doctorId,
          "onUpdate:doctor": _cache[3] || (_cache[3] = ($event: any) => ((form.values.doctorId) = $event)),
          requiresDoctorPaymentFormation: form.values.requiresDoctorPaymentFormation,
          "onUpdate:requiresDoctorPaymentFormation": _cache[4] || (_cache[4] = ($event: any) => ((form.values.requiresDoctorPaymentFormation) = $event)),
          "company-err": formErrors.value.company,
          "health-unit-err": formErrors.value.healthUnit,
          "schedule-err": formErrors.value.schedule
        }, null, 8, ["stacked", "company", "health-unit", "schedule", "doctor", "requiresDoctorPaymentFormation", "company-err", "health-unit-err", "schedule-err"]),
        _hoisted_3,
        (coverageSupported.value)
          ? (_openBlock(), _createBlock(CoverageModeSelector, {
              key: 0,
              modelValue: form.values.coverage,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.values.coverage) = $event)),
              "allow-unidentified": allowUnidentified.value,
              "unidentified-locked": _unref(unidentifiedLocked),
              "can-open-schedule-settings": _unref(canOpenScheduleSettings),
              class: "mb-4",
              onOpenScheduleSettings: _cache[6] || (_cache[6] = ($event: any) => (_unref(openScheduleSettings)(closeModal)))
            }, null, 8, ["modelValue", "allow-unidentified", "unidentified-locked", "can-open-schedule-settings"]))
          : _createCommentVNode("", true),
        (coverageSupported.value && isUnidentified.value)
          ? (_openBlock(), _createBlock(CoverageResponsibleField, {
              key: 1,
              "responsible-id": form.values.coverageResponsibleId,
              "onUpdate:responsibleId": _cache[7] || (_cache[7] = ($event: any) => ((form.values.coverageResponsibleId) = $event)),
              note: form.values.coverageNote,
              "onUpdate:note": _cache[8] || (_cache[8] = ($event: any) => ((form.values.coverageNote) = $event)),
              "health-unit-id": Number(form.values.healthUnit) || null,
              "health-unit-name": selectedHealthUnitName.value,
              error: formErrors.value.coverageResponsibleId,
              class: "mb-4"
            }, null, 8, ["responsible-id", "note", "health-unit-id", "health-unit-name", "error"]))
          : _createCommentVNode("", true),
        _createVNode(DoctorInfosForm, {
          stacked: __props.mobileShell,
          "hide-doctor": !isDoctorMode.value,
          "team-locked": isUnidentified.value,
          doctor: form.values.doctorId,
          "onUpdate:doctor": onDoctorSelected,
          value: form.values.value,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.values.value) = $event)),
          inCash: form.values.inCash,
          "onUpdate:inCash": _cache[11] || (_cache[11] = ($event: any) => ((form.values.inCash) = $event)),
          advanceRequested: form.values.advanceRequested,
          "onUpdate:advanceRequested": _cache[12] || (_cache[12] = ($event: any) => ((form.values.advanceRequested) = $event)),
          schedule: form.values.schedule,
          "onUpdate:schedule": _cache[13] || (_cache[13] = ($event: any) => ((form.values.schedule) = $event)),
          advancePaid: form.values.advancePaid,
          "onUpdate:advancePaid": _cache[14] || (_cache[14] = ($event: any) => ((form.values.advancePaid) = $event)),
          formation: form.values.formation,
          "onUpdate:formation": _cache[15] || (_cache[15] = ($event: any) => ((form.values.formation) = $event)),
          shift: form.values.shift,
          "onUpdate:shift": _cache[16] || (_cache[16] = ($event: any) => ((form.values.shift) = $event)),
          position: form.values.position,
          "onUpdate:position": _cache[17] || (_cache[17] = ($event: any) => ((form.values.position) = $event)),
          configurationRepetition: form.values.configurationRepetition,
          "onUpdate:configurationRepetition": _cache[18] || (_cache[18] = ($event: any) => ((form.values.configurationRepetition) = $event)),
          team: form.values.team,
          "onUpdate:team": _cache[19] || (_cache[19] = ($event: any) => ((form.values.team) = $event)),
          urlConviteDoctor: form.values.urlConviteDoctor,
          company: form.values.company,
          "show-formation-field": 
          !!(form.values.requiresDoctorPaymentFormation && form.values.doctorId)
        ,
          "position-err": formErrors.value.position,
          "shift-err": formErrors.value.shift,
          disabled: !form.values.company || !form.values.healthUnit || !form.values.schedule
        }, {
          default: _withCtx(() => [
            (!!form.values.doctorId)
              ? (_openBlock(), _createBlock(SelectUserSponsor, {
                  key: 0,
                  modelValue: form.values.userSponsorId,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.values.userSponsorId) = $event)),
                  schedule: form.values.schedule,
                  disabled: !form.values.schedule,
                  "user-sponsor-id-err": formErrors.value.userSponsorId
                }, null, 8, ["modelValue", "schedule", "disabled", "user-sponsor-id-err"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["stacked", "hide-doctor", "team-locked", "doctor", "value", "inCash", "advanceRequested", "schedule", "advancePaid", "formation", "shift", "position", "configurationRepetition", "team", "urlConviteDoctor", "company", "show-formation-field", "position-err", "shift-err", "disabled"]),
        (_unref(isDashboardV2))
          ? (_openBlock(), _createBlock(SectorSpecialtyFields, {
              key: 2,
              class: "mt-6",
              "health-unit-id": form.values.healthUnit ? Number(form.values.healthUnit) : null,
              "company-id": form.values.company ? Number(form.values.company) : null,
              sector: form.values.sector,
              specialty: form.values.specialty,
              "sector-hint": sectorSuggested.value ? LAST_USED_HINT : null,
              "specialty-hint": specialtySuggested.value ? LAST_USED_HINT : null,
              summary: recurrenceSummary.value,
              disabled: !form.values.schedule,
              description: "Onde o plantão acontece e qual especialidade ele pede. Vale só para este plantão: não altera a posição, o turno nem a escala.",
              "onUpdate:sector": onSectorChange,
              "onUpdate:specialty": onSpecialtyChange
            }, null, 8, ["health-unit-id", "company-id", "sector", "specialty", "sector-hint", "specialty-hint", "summary", "disabled"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createVNode(_component_v_radio_group, {
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (form.values.stationType = $event)),
              "model-value": form.values.stationType,
              inline: "",
              class: "flex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio, {
                  label: "Fixo",
                  color: "primary",
                  value: "FIXO"
                }),
                _createVNode(_component_v_radio, {
                  label: "Cobertura",
                  color: "primary",
                  value: "COBERTURA"
                })
              ]),
              _: 1
            }, 8, ["model-value"])
          ])
        ]),
        _createVNode(HourAndDateForm, {
          isUpdateMode: false,
          date: form.values.date,
          "onUpdate:date": _cache[21] || (_cache[21] = ($event: any) => ((form.values.date) = $event)),
          endDate: form.values.endDate,
          "onUpdate:endDate": _cache[22] || (_cache[22] = ($event: any) => ((form.values.endDate) = $event)),
          timezone: form.values.timezone,
          "onUpdate:timezone": _cache[23] || (_cache[23] = ($event: any) => ((form.values.timezone) = $event)),
          startHour: form.values.startHour,
          "onUpdate:startHour": _cache[24] || (_cache[24] = ($event: any) => ((form.values.startHour) = $event)),
          endHour: form.values.endHour,
          "onUpdate:endHour": _cache[25] || (_cache[25] = ($event: any) => ((form.values.endHour) = $event)),
          "configuration-repetition": form.values.configurationRepetition,
          "onUpdate:configurationRepetition": _cache[26] || (_cache[26] = ($event: any) => ((form.values.configurationRepetition) = $event)),
          "value-repetition": form.values.valueRepetition,
          "onUpdate:valueRepetition": _cache[27] || (_cache[27] = ($event: any) => ((form.values.valueRepetition) = $event)),
          "finished-at-until": form.values.finishedAtUntil,
          "onUpdate:finishedAtUntil": _cache[28] || (_cache[28] = ($event: any) => ((form.values.finishedAtUntil) = $event)),
          "finished-at-after": form.values.finishedAtAfter,
          "onUpdate:finishedAtAfter": _cache[29] || (_cache[29] = ($event: any) => ((form.values.finishedAtAfter) = $event)),
          "repetition-days": form.values.repetionDays,
          "onUpdate:repetitionDays": _cache[30] || (_cache[30] = ($event: any) => ((form.values.repetionDays) = $event)),
          "finished-at": form.values.finishedAt,
          "onUpdate:finishedAt": _cache[31] || (_cache[31] = ($event: any) => ((form.values.finishedAt) = $event)),
          "onUpdate:positionsByRowStations": _cache[32] || (_cache[32] = ($event: any) => (form.values.positionByRowStations = $event)),
          schedule: form.values.schedule,
          scheduleEndDate: scheduleEndDate.value,
          "repetition-err": formErrors.value.repetitionErr,
          onValidationStatus: handleValidation,
          "date-err": formErrors.value.date,
          "start-hour-err": formErrors.value.startHour,
          "end-date-err": formErrors.value.endDate,
          "end-hour-err": formErrors.value.endHour,
          "position-err": formErrors.value.positionErr
        }, null, 8, ["date", "endDate", "timezone", "startHour", "endHour", "configuration-repetition", "value-repetition", "finished-at-until", "finished-at-after", "repetition-days", "finished-at", "schedule", "scheduleEndDate", "repetition-err", "date-err", "start-hour-err", "end-date-err", "end-hour-err", "position-err"]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, _toDisplayString(proportionalityRuleTitle.value), 1)
        ]),
        _createVNode(ConsecutiveHoursBlockAlert, {
          violations: _unref(consecutiveHoursViolations),
          class: "mb-6"
        }, null, 8, ["violations"]),
        _createVNode(ScheduleOverlapAlert, {
          alerts: _unref(overlapAlerts),
          mode: "create",
          class: "mb-6"
        }, null, 8, ["alerts"]),
        (_unref(placeholderBlocked).isOpen.value)
          ? (_openBlock(), _createBlock(PlaceholderDoctorBlockedModal, {
              key: 3,
              modelValue: _unref(placeholderBlocked).isOpen.value,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(placeholderBlocked).isOpen.value) = $event)),
              "doctor-name": _unref(placeholderBlocked).doctorName.value,
              "allow-unidentified": allowUnidentified.value,
              onUseUnidentified: onUseUnidentified
            }, null, 8, ["modelValue", "doctor-name", "allow-unidentified"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["open", "full-screen"]))
}
}

})